import WeatherTimeline from './weather-timeline';

const weatherTimelineConfig = {
  name: 'weatherTimeline',
  class: WeatherTimeline,
  querySelector: {
    timelineContent: '.weather-timeline__timeline-content',
    detailPanel: '.weather-timeline__detail-panel',
    detailPanelCloseButton: '.weather-timeline__detail-close-button',
    detailPanelDate: '.weather-timeline__detail-date',
    detailPanelDayTime: '.weather-timeline__detail-conditions__daytime',
    detailPanelNightTime: '.weather-timeline__detail-conditions__nighttime',
    detailPanelUvIndex: '.weather-timeline__detail-stats__uv-index',
    detailPanelHumidity: '.weather-timeline__detail-stats__humidity',
  },
  querySelectorAll: {
    timelineItems: '.weather-timeline__timeline-item',
  },
  options: {
    slickOptions: {
      mobileFirst: true,
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
    },
  },
};

export default weatherTimelineConfig;

